const NewFavIcon = ({
  width = 14,
  height = 13,
  fill = "#1C473B",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.9987 0C12.0238 0 13.6654 1.66667 13.6654 4C13.6654 8.66667 8.66536 11.3333 6.9987 12.3333C5.33203 11.3333 0.332031 8.66667 0.332031 4C0.332031 1.66667 1.9987 0 3.9987 0C5.23868 0 6.33203 0.666667 6.9987 1.33333C7.66536 0.666667 8.7587 0 9.9987 0ZM7.6213 10.4025C8.20903 10.0323 8.7387 9.66367 9.2353 9.2686C11.2212 7.68867 12.332 5.96233 12.332 4C12.332 2.42717 11.3074 1.33333 9.9987 1.33333C9.28143 1.33333 8.5049 1.71274 7.9415 2.27614L6.9987 3.21895L6.0559 2.27614C5.49248 1.71274 4.71596 1.33333 3.9987 1.33333C2.70474 1.33333 1.66536 2.43767 1.66536 4C1.66536 5.96233 2.77621 7.68867 4.76212 9.2686C5.2587 9.66367 5.78836 10.0323 6.3761 10.4025C6.5751 10.5279 6.77276 10.6486 6.9987 10.7835C7.22463 10.6486 7.4223 10.5279 7.6213 10.4025Z"
      fill={fill}
    />
  </svg>
);

export default NewFavIcon;
